import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';
import striptags from 'striptags';
import { find } from 'lodash';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Video from '../parts/video_tile.jsx';
import ArtistIntro from '../parts/artist_intro.jsx';

class Director extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      introHiding: false,
      introHidden: false,
      informationShown: false
    };
  }

  componentDidMount(){
    setTimeout(() => {
      this.setState({introHiding: true});
      setTimeout(() => {
        this.setState({introHidden: true});
      }, 800);
    }, 25 * 146);
  }

  _handleClick = () => {
    this.setState({informationShown: !this.state.informationShown});
  }
  render () {
    const { director } = this.props;
    const fromDetailView = this.props.location.state && this.props.location.state.fromDetailView;

    if(!director || director.acf.hide_artist){
      return false;
    }

    return <div className={classNames('page page--artist transition', {
        'page--artist--information': this.state.informationShown
      })} style={{backgroundColor: director.acf.secondary_color}}>
        <Helmet>
          <meta name='description' content={striptags(director.content.rendered)} />
          <meta name='og:description' content={striptags(director.content.rendered)} />
        </Helmet>
        <ArtistIntro
          hiding={this.state.introHiding}
          hidden={this.state.introHidden || fromDetailView}
          colors={{
            primary: director.acf.primary_color,
            secondary: director.acf.secondary_color,
            information: director.acf.information_text_color
          }}
          artist={director}
          onLabelClick={() => this._handleClick()}
          />
        <div className="artist__stream" style={{backgroundColor: director.acf.secondary_color}}>
          {director.acf.videos && director.acf.videos.map((item, i) => {
            const { preview_video } = item;
            const { title, client, ...videoRest } = item.video;
            const previewVideo = preview_video ? preview_video : videoRest;

            return <Video
              to={`/directors/${director.slug}/${item.video.id}`}
              key={item.video.id}
              teaser={i == 0}
              hover={true}
              subtitle={item.client}
              poster={item.poster}
              colors={{primary: director.acf.primary_color, secondary: director.acf.secondary_color}}
              {...previewVideo}
              title={item.title}
               />
          })}
        </div>
      </div>;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { directors } = state.directors;

  if(directors.length < 1){
    return {};
  }

  const director = find(directors, {slug: ownProps.match.params.slug});

  return {
    director
  }
}

export default withRouter(connect(mapStateToProps, null)(Director));
